import type { FC } from 'react';
import cn from 'classnames';

import OPE from 'js/on-page-editing';

import ArticleHeader from 'components/article-header/ArticleHeader';
import ContentArea from 'components/content-area/ContentArea';
import { ContentWithSidebar, Content, Sidebar } from 'components/content-with-sidebar';
import RichText from 'components/rich-text/RichText';
import PageFooter from 'components/page-footer/PageFooter';
import Heading from 'components/heading/Heading';
import ImageWithCaption from 'components/image-with-caption/ImageWithCaption';

import { FetchPrioritySelector, IArticlePage } from 'source/NFR.types';

const ArticlePage: FC<IArticlePage> = ({
  content,
  footer,
  header,
  ingress,
  onPageEditing,
  sidebar,
  title,
  image,
  hasLargeTitle
}) => (
  <>
    <ContentWithSidebar>
      <Content>
        {title && (
          <Heading
            className={cn({ 'article-page--title--large': hasLargeTitle })}
            level={1}
            data-epi-type="title"
            {...OPE(onPageEditing?.title)}
          >
            {title}
          </Heading>
        )}
      </Content>
      <Sidebar />
    </ContentWithSidebar>

    <ContentWithSidebar>
      <Content>
        <div data-epi-type="content">
          {(ingress || onPageEditing?.ingress) && (
            <div className="article-page--ingress" {...OPE(onPageEditing?.ingress)}>
              <p>{ingress}</p>
            </div>
          )}
          <ArticleHeader {...header} />
          {image && <ImageWithCaption {...image} fetchPriority={FetchPrioritySelector.High} />}
          <RichText {...content} />
        </div>
      </Content>

      <Sidebar className="article-page--sidebar">
        <ContentArea enableElementSizing={false} {...sidebar} />
      </Sidebar>
    </ContentWithSidebar>

    {footer && (
      <ContentWithSidebar>
        <Content>
          <div className="article-page--footer" data-epi-type="content">
            <PageFooter {...footer} />
          </div>
        </Content>
      </ContentWithSidebar>
    )}
  </>
);

ArticlePage.displayName = 'ArticlePage';

export default ArticlePage;
